// Filename - pages/AboutUs.js

import React from "react";

export const About = () => {
    return (
        <div className="welcome">
            <table align="center" width="90%">
                <tr align="center">
                    <td align="center">
                        <h3>
                            About InfoTrawl
                        </h3>
                    </td>
                </tr>
            </table>
        </div>
    );
};
